module.exports = __webpack_public_path__ + "img/logo.4b604ac6.png";